import Button from "Components/button";
import classNames from "classnames";
import isFunction from "lodash/isFunction";
import React, { memo, useCallback } from "react";
import { needMessageLink } from "./utils";
function MessageLink(props) {
    const { className, href, title, icon, onClick, ...other } = props;
    const handleClick = useCallback(() => {
        isFunction(onClick) && onClick();
        if (href)
            window.location.hash = href;
    }, [onClick, href]);
    if (!needMessageLink(props))
        return null;
    return (React.createElement(Button, { className: classNames(className, "text-overflow-ellipsis"), onClick: handleClick, ...other },
        icon && React.createElement("i", { className: icon }),
        title || href));
}
export default memo(MessageLink);
MessageLink.defaultProps = {
    height: 28
};
